<template>
  <div class="search-bar-wrapper" :class="{ dark }">
    <form
      action=""
      method="post"
      @submit.prevent=""
    >
      <div class="search-bar-holder">
        <div class="search-bar">
          <input
            v-model="keyword"
            type="text"
            name="search"
            autocomplete="off"
            :placeholder="placeholder"
            @focus="$emit('focus', keyword)"
          >
          <SearchBarIcon class="search-icon" />
          <CloseIcon v-if="keyword" class="close-btn" @click="clearInput" />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { delayOnKeyup } from '../utils/helper';
import SearchBarIcon from '../assets/svg/icon-search.svg?vue-component';
import CloseIcon from '../assets/svg/close-icon.svg?vue-component';

export default {
  components: {
    SearchBarIcon,
    CloseIcon,
  },
  props: {
    placeholder: { type: String, default: '', required: true },
    value: { type: String, default: '', required: false },
    dark: Boolean,
  },
  data() {
    return {
      keyword: this.value,
    };
  },
  watch: {
    keyword() {
      delayOnKeyup(async () => {
        this.$emit('search', this.keyword);
      });
    },
    value(v) {
      this.keyword = v;
    },
  },
  methods: {
    clearInput() {
      this.keyword = '';
    },
  },
};
</script>

<style lang="scss" scoped>
.search-bar-wrapper {
  width: 100%;

  &.dark {
    form {
      .search-bar {
        input {
          background: var(--main-dark-light-1);
          border: 1px solid var(--main-dark-light-2);
          border-radius: 500px;
          color: var(--main-light);

          &::placeholder {
            color: var(--main-light-shade-4);
          }
        }

        .search-icon {
          path[stroke] {
            stroke: #767C87;
          }
        }

        .close-btn {
          path[fill] {
            fill: #767C87;
          }
        }
      }
    }
  }

  form {
    .search-bar {
      position: relative;

      input {
        border: 1px solid #F0F0F2;
        border-radius: var(--spacing-100);
        padding: 12px 54px;
      }

      .search-icon {
        position: absolute;
        left: 21px;
        top: 12px;

        path[stroke] {
          stroke: var(--main-light-shade-4);
        }
      }

      .close-btn {
        position: absolute;
        right: 16px;
        top: 17px;
        cursor: pointer;

        path[fill] {
          fill: var(--main-light-shade-3);
        }
      }
    }
  }
}
</style>
